import Skeleton from "@mui/material/Skeleton";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

/**
 * Horizontal gutter around each placeholder bar. Vertical padding stays at 0 so a row
 * measures exactly `rowHeight` whatever padding the table's real rows carry.
 */
const CELL_PADDING = "0 6px";

interface ReprintAuthSkeletonProps {
  /** The list's page size, so the placeholder fills as many rows as the answer will. */
  rows: number;
  columns: number;
  /**
   * Full height of one loaded row, padding included. Holding the placeholder at the same
   * height is what keeps the table its final size while loading, so nothing below it
   * moves when the data lands.
   */
  rowHeight: number;
}

export default function ReprintAuthSkeleton({
  rows,
  columns,
  rowHeight,
}: ReprintAuthSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <TableRow
          key={index}
          sx={{ height: rowHeight, "& td, & th": { padding: CELL_PADDING } }}
        >
          {Array.from({ length: columns }).map((__, colIndex) => (
            <TableCell key={colIndex}>
              <Skeleton variant="text" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
